import React from 'react';
import { SeoHead } from './components/SeoHead';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AeoSummary } from './components/AeoSummary';
import { Results } from './components/Results';
import { SettlementCalculator } from './components/SettlementCalculator';
import { ExposureSites } from './components/ExposureSites';
import { CaliforniaResources } from './components/CaliforniaResources';
import { Faq } from './components/Faq';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-50 flex flex-col font-sans selection:bg-brand-accent selection:text-brand-900" data-id="element-0" data-mp="31ayr642drs0c">
      <SeoHead data-id="element-1" data-mp="2wj8f9tnsow6t" />
      <Header data-id="element-2" data-mp="2wip7v6vrtq71" />

      <main className="flex-grow" data-id="element-3" data-mp="2wi5nzkmk8rqd">
        <Hero data-id="element-4" data-mp="28tw972nrl48q" />
        <AeoSummary data-id="element-5" data-mp="28te3lff7pdo5" />
        <Results data-id="element-6" data-mp="28sur4e8bzhhi" />
        <SettlementCalculator data-id="element-7" data-mp="28sbe9bxjfjac" />
        <ExposureSites data-id="element-8" data-mp="23vune9yyeqtk" />
        <CaliforniaResources data-id="element-9" data-mp="23u9q4cl98ts0" />
        <Faq data-id="element-10" data-mp="23t8heerpojdg" />
        <Contact data-id="element-11" data-mp="23ti6m04xmmi3" />
      </main>

      <Footer data-id="element-12" data-mp="3ikh5q2ysagvt" />
    </div>;
}